<template lang="pug">
.charts
    .piechart(ref="piechart", v-show="!isOptionEmpty")
    .emptychart(v-show="isOptionEmpty")
    .loadingchart(v-show="isLoading")
</template>

<script>
import { pieChartOptionFactory } from "./options.js"
import resizeMixin from './resize.mixin.js'

export default {
    mixins: [resizeMixin],
    props: {
        fromAttr: {
          type: Boolean,
          default: false
        },
        comp: {
          type: Boolean,
          default: false
        },
        legend: Array,
        series: Array,
        height: {
            type: [Number, String],
            default: 300
        },
        option: Object,
        color: Array
    },
    data(){
        return {
            chart: null
        }
    },
    computed: {
      isOptionEmpty: function() {
        return _.isEmpty(this.legend) || _.isEmpty(this.series) || (!_.isEmpty(this.series) && this.allSeriesEmpty(this.series))

      },
      isLoading() {
        return this.$store.state.chartLoading
      }
    },
    methods: {
        initChart() {
            let dom = this.$refs.piechart
            if(dom){
              this.chart = echarts.init(dom, null, {height: this.height})
            }
        },
        allSeriesEmpty(series){
          let i= 0, l= series.length;
          while(i<l){
            if(series[i].data === void(0) || (series[i].data !== void(0) && !_.isEmpty(this.series[i].data)))
              return false;
            else if(series[i].data !== void(0) && _.isEmpty(this.series[i].data))
              i++;
          }
          return true;
        },
        draw() {
            if (!this.chart && !this.isOptionEmpty) {
                this.initChart()
            }
            this.chart && this.chart.setOption(pieChartOptionFactory({
                fromAttr: this.fromAttr,
                comp: this.comp,
                color: this.color,
                legendData: this.legend,
                seriesItems: this.series,
                customOptions: this.option || {}
            }), {
              notMerge: true
            })
        }
    },
    updated(){
        this.draw()
    },
    mounted(){
        this.draw()
    },
    destroyed() {
      this.chart = null
    }
}
</script>



// WEBPACK FOOTER //
// pieChart.vue?68302256